import { relations, sql } from "drizzle-orm";
import { boolean, date, integer, jsonb, pgEnum, pgTable, text, timestamp, uuid, } from "drizzle-orm/pg-core";
import { dossierDocument } from "./dossier.js";
import { hdnLoanApplication, hdnMessage } from "./hdn.js";
import { agency } from "./main.js";
export const loanOfferTypeEnum = pgEnum("offer_type", ["preliminary", "final"]);
export const loanOfferTable = pgTable("hdn_loan_offer", {
    type: loanOfferTypeEnum("offer_type").notNull(),
    passingDate: date("passing_date", { mode: "string" }),
    acceptanceDate: date("acceptance_date", { mode: "string" }),
    extensionPossible: boolean("extension_possible"),
    mustReturnSignedCopy: boolean("must_return_signed_copy"),
    description: jsonb("description").$type(),
    id: uuid("id")
        .default(sql `uuid_generate_v4()`)
        .primaryKey()
        .notNull(),
    loanApplicationId: uuid("loan_application_id")
        .notNull()
        .references(() => hdnLoanApplication.id, {
        onDelete: "cascade",
        onUpdate: "cascade",
    }),
    createdAt: timestamp("created_at", {
        withTimezone: true,
        mode: "string",
    })
        .defaultNow()
        .notNull(),
});
export const offerRelations = relations(loanOfferTable, ({ one, many }) => ({
    application: one(hdnLoanApplication, {
        fields: [loanOfferTable.loanApplicationId],
        references: [hdnLoanApplication.id],
    }),
    documents: many(offerDocument),
}));
export const offerDocument = pgTable("hdn_offer_document", {
    volgnummer: integer("volgnummer").notNull(),
    docSoort: text("doc_soort").notNull(),
    docSoortOmschrijving: text("doc_soort_omschrijving"),
    storedDocumentId: uuid("stored_document_id")
        .notNull()
        .primaryKey()
        .references(() => dossierDocument.id, {
        onDelete: "cascade",
        onUpdate: "cascade",
    }),
    hdnMessageId: uuid("hdn_message_id")
        .notNull()
        .references(() => hdnMessage.id, {
        onDelete: "cascade",
        onUpdate: "cascade",
    }),
    hdnLoanApplicationId: uuid("hdn_loan_application_id")
        .notNull()
        .references(() => hdnLoanApplication.id, {
        onDelete: "cascade",
        onUpdate: "cascade",
    }),
    loanOfferId: uuid("hdn_loan_offer_id")
        .notNull()
        .references(() => loanOfferTable.id, {
        onDelete: "cascade",
        onUpdate: "cascade",
    }),
    agencyId: uuid("agency_id")
        .notNull()
        .references(() => agency.id, {
        onDelete: "cascade",
        onUpdate: "cascade",
    }),
    receivedAt: timestamp("received_at", {
        withTimezone: true,
        mode: "string",
    })
        .notNull()
        .defaultNow(),
    createdAt: timestamp("created_at", {
        withTimezone: true,
        mode: "string",
    })
        .defaultNow()
        .notNull(),
});
export const offerDocumentRelations = relations(offerDocument, ({ one }) => ({
    storedDocument: one(dossierDocument, {
        fields: [offerDocument.storedDocumentId],
        references: [dossierDocument.id],
    }),
    loanOffer: one(loanOfferTable, {
        fields: [offerDocument.loanOfferId],
        references: [loanOfferTable.id],
    }),
    message: one(hdnMessage, {
        fields: [offerDocument.hdnMessageId],
        references: [hdnMessage.id],
    }),
    loanApplication: one(hdnLoanApplication, {
        fields: [offerDocument.hdnLoanApplicationId],
        references: [hdnLoanApplication.id],
    }),
    agency: one(agency, {
        fields: [offerDocument.agencyId],
        references: [agency.id],
    }),
}));
